import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import Tooltip from 'components/Tooltip/Tooltip';

import { UserStoreKC, ViewKeys } from 'stores/userStoreKC';
import { EdwardColors } from 'enums';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    demoButton: {
      marginBottom: 10,
      marginTop: '-5px',
      textAlign: 'right',
    },
    detail: {
      position: 'absolute',
      right: 0,
      top: 0,
      '&.hidden': {
        top: '-28px'
      }
    }
  }),
);

interface Props {
  userStore: UserStoreKC;
  detail?: boolean;
}

const DemoModeButton: React.FC<Props> = ({ userStore, detail }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={`${detail ? classes.detail:''} ${userStore.view[ViewKeys.DEMO_MODE] ? 'hidden':''}`}>
      {userStore && (
        <Tooltip
          title={t(`${userStore.view[ViewKeys.DEMO_MODE] ? 'demoMode_on' : 'demoMode_off'}`) || ''}
          placement="top"
        >
          <IconButton
            size="medium"
            onClick={() => userStore.setViewSetting(ViewKeys.DEMO_MODE, !userStore.view[ViewKeys.DEMO_MODE])}
          >
            {userStore.view[ViewKeys.DEMO_MODE] ? (
              <VisibilityOff fontSize="inherit" htmlColor={EdwardColors.SECONDARY} />
            ) : (
              <Visibility fontSize="inherit" htmlColor={EdwardColors.SECONDARY} />
            )}
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default (observer)(DemoModeButton);
